exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".signIn-module-infobox{font-size:13px;line-height:1.38;color:#992631;margin:32px auto}.signIn-module-infobox .icon-container{margin-right:8px;background-color:#992631;border-radius:50%}.signIn-module-infobox .icon-container i{font-size:16px;opacity:1}", ""]);

// Exports
exports.locals = {
	"infobox": "signIn-module-infobox"
};